import React, { Component } from 'react'
import { graphql, compose, gql } from 'react-apollo'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import { client } from '../../../../index'
import { Loader, Form, TextInput } from '../../../UI'
import _ from 'lodash'
import Geosuggest from 'react-geosuggest'
import { validateRequired } from '../../../../libs/validation'
import CREATE_LOCAL_TOUR from '../../../../graphql/ActivitySteps/CreateLocalTour.graphql'
import UPDATE_LOCAL_TOUR from '../../../../graphql/ActivitySteps/UpdateLocalTourTitleTags.graphql'
import { NotificationManager } from 'react-notifications'

class TitleTags extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    currentSteps: PropTypes.object,
    createLocalTour: PropTypes.func,
    updateLocalTour: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      saving: false,
      description: ''
    }
  }

  componentWillMount() {
    let tags

    if (Array.isArray(this.props.currentSteps.tags) && this.props.currentSteps.tags.length) {
      tags = this.props.currentSteps.tags.map(tag => tag.value).join(', ')
    }

    this.setState((state, props) => ({
      title: get(props, 'currentSteps.title'),
      tags: tags || '',
      city: _.get(props, 'currentSteps.tourLocation.city', ''),
      country: _.get(props, 'currentSteps.tourLocation.country', ''),
      description: _.get(props, 'currentSteps.tourLocation.description', ''),
      markers: [
        { position: { lng: _.get(props, 'currentSteps.tourLocation.lng', 0), lat: _.get(props, 'currentSteps.tourLocation.lat', 0) } }
      ]
    }))
  }

  componentWillReceiveProps(next) {
    const localTour = _.head(next.data.allLocalTours)
    document.getElementById('auto_div_activity').placeholder = _.get(localTour, 'tourLocation.description', '')
    if (Array.isArray(next.data.allLocalTours) && next.data.allLocalTours.length) {
      this.setState(() => ({
        id: localTour.id,
        title: localTour.title,
        tags: localTour.tags.map(tag => tag.value).join(', ') || '',
        city: _.get(next, 'currentSteps.tourLocation.city', ''),
        country: _.get(next, 'currentSteps.tourLocation.country', ''),
        description: _.get(next, 'currentSteps.tourLocation.description', ''),
        markers: [
          { position: { lng: _.get(next, 'currentSteps.tourLocation.lng', 0), lat: _.get(next, 'currentSteps.tourLocation.lat', 0) } }
        ]
      }))
    }
  }

  handleSubmit = values => {
    const marker = _.head(this.state.markers)
    const localTour = _.head(this.props.data.allLocalTours)
    this.setState(
      () => ({
        saving: true
      }),
      async () => {
        let tags = []

        if (typeof values.tags === 'string' && values.tags.length) {
          tags = values.tags.split(',').map(tag => ({
            value: tag.trim()
          }))
          this.props.updateSteps()
        }

        let location = await client.query({
          query: locationQuery,
          variables: {
            lat: marker.position.lat,
            lng: marker.position.lng
          }
        })

        location = _.head(location.data.allLocations)

        if (!location) {
          location = await client.mutate({
            mutation: createLocation,
            variables: {
              city: this.state.city,
              country: this.state.country,
              lng: marker.position ? marker.position.lng : marker.lng,
              lat: marker.position ? marker.position.lat : marker.lat,
              description: this.state.description
            }
          })
          location = location.data.createLocation
        }
        let operation

        if (this.props.data && Array.isArray(this.props.data.allLocalTours) && this.props.data.allLocalTours.length) {
          operation = this.props.updateLocalTour({
            variables: {
              id: localTour.id,
              title: values.title,
              tags: tags,
              tourLocation: location.id
            }
          })
        } else {
          operation = this.props.createLocalTour({
            variables: {
              title: values.title,
              tags: tags,
              usersIds: [],
              activityStatus: 'WaitingForApproval',
              minGroupSize: 0,
              maxGroupSize: 0,
              whatWeDo: '',
              whatWeProvide: '',
              whatYouBring: '',
              whereWeBe: '',
              categories: [],
              languages: [],
              estimatedDurationHours: 0,
              privateTourPrice: 0,
              groupPrice: 0,
              tourDates: [],
              shortDescription: '',
              tripGuideId: this.props.user.id,
              tourLocation: location.id
            }
          })
        }

        const result = await operation

        NotificationManager.success('Title and tags updated', 'Success', 5000)

        this.setState(
          () => ({
            saving: false
          }),
          () => {
            if (localTour) {
              this.props.updateSteps()
              this.props.history.push(`/activity-steps/${localTour.id}/languages`)
            } else {
              this.props.updateSteps()
              this.props.history.push('/activity-steps/languages')
            }
          }
        )
      }
    )
  }

  onPlaceSelect(place, address, e) {
    const country = address ? address.filter(item => item.types.includes('country'))[0].long_name : ''
    const city = address
      ? _.get(address.filter(item => item.types.includes('locality') || item.types.includes('postal_town'))[0], 'long_name', '')
      : ''

    this.setState({
      place,
      country,
      markers: [
        {
          position: {
            lat: _.get(e, 'location.lat', 0),
            lng: _.get(e, 'location.lng', 0)
          },
          defaultAnimation: 2
        }
      ],
      placeError: false,
      city: city,
      description: place
    })
  }

  onPlacesError(status) {
    if (status !== 'ZERO_RESULTS') {
      console.warn('GOOGLE PLACES ERROR', status)
    }
  }

  render() {
    const { t } = this.props

    if (this.props.loading) {
      return <Loader showLoader={true} />
    }

    let location

    if (_.get(this.props, 'currentSteps.tourLocation', null)) {
      location = _.get(this.props, 'currentSteps.tourLocation.description', '')
    } else {
      location = _.get(this.props, 'data.allLocalTours[0].tourLocation.description', '')
    }

    return (
      <div className="steps-screen__form step-form faded-container">
        <div className="steps-screen__form-title">{t('trip_title')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger"
          submitBtnName={t('main:save_continue')}
          submittingToServer={this.state.saving}
        >
          <div className="steps-screen__form-input-area">
            <div>
              <div className="steps-screen__form-subtitle">{t('type_title')}</div>
              <div style={{ marginBottom: 25 }}>
                <TextInput
                  id="title"
                  value={this.state.title}
                  placeholder="Example: Shopping in Tokyo!"
                  initialValue={this.state.title}
                  maxChars={50}
                  validationFuncs={[validateRequired]}
                  extraClass=""
                  labelClass="steps-screen__form-input-label"
                />
              </div>
            </div>

            <div style={{ marginBottom: 25 }}>
              <div className="steps-screen__form-subtitle">Activity location</div>

              <Geosuggest
                ref={input => (this.locationControl = input)}
                id={'auto_div_activity'}
                initialValue={location}
                // placeholder='Enter city or country'
                // disabled={disabled}
                // onBlur={this.handleBlur}
                onSuggestSelect={e => {
                  this.onPlaceSelect(_.get(e, 'gmaps.formatted_address', ''), _.get(e, 'gmaps.address_components', null), e)
                }}
                types={['(regions)']}
                inputClassName="locationControl"
              />
            </div>

            <div>
              <div className="steps-screen__form-subtitle">{t('add_tags')}</div>
              <TextInput
                id="tags"
                placeholder={t('tags_placeholder')}
                initialValue={this.state.tags}
                maxChars={50}
                extraClass=""
                labelClass="steps-screen__form-input-label"
              />
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

const locationQuery = gql`
  query locationQuery($lat: Float!, $lng: Float!) {
    allLocations(filter: { lat: $lat, lng: $lng }) {
      id
      country
      city
      lat
      lng
      description
    }
  }
`

const createLocation = gql`
  mutation createLocation($country: String!, $city: String!, $lat: Float!, $lng: Float!, $description: String!) {
    createLocation(country: $country, city: $city, lat: $lat, lng: $lng, description: $description) {
      id
      country
      city
      lat
      lng
      description
    }
  }
`

export default compose(
  translate('activity_steps'),
  graphql(createLocation, {
    name: 'createLocation'
  }),
  graphql(CREATE_LOCAL_TOUR, {
    name: 'createLocalTour'
  }),
  graphql(UPDATE_LOCAL_TOUR, {
    name: 'updateLocalTour'
  }),
  withRouter
)(TitleTags)



// WEBPACK FOOTER //
// src/components/ActivitySteps/Steps/MainInfo/TitleTags.jsx